import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { map } from 'rxjs/operators';
import { Client, ClientBilling, ClientConfig } from '../restaurant-manager.models';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ClientService {

    constructor(protected apiService: ApiService) { }

    get(): Observable<Client> {
        return this.apiService.get<Client>('', true).pipe(map((client: Client) => {
            return client?.id ? new Client(client) : null;
        }));
    }

    getConfig(): Observable<ClientConfig> {
        return this.apiService.get<ClientConfig>('/config', true).pipe(map((clientConfig: ClientConfig) => {
            return clientConfig?.id ? new ClientConfig(clientConfig) : null;
        }));
    }

    getBilling(): Observable<ClientBilling> {
        return this.apiService.get<ClientBilling>('/billing', true).pipe(map((clientBilling: ClientBilling) => {
            return new ClientBilling(clientBilling);
        }));
    }

}
